export default __webpack_public_path__ + "static/media/nature-time.9ffe9e32.png";